import EventTypes from "../../../shared/EventTypes";
import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class RemovePolyCoordinateAction extends AbstractProvidedClass {
    constructor(provider, element, index) {
        super(provider);

        this.element = element;
        this.coordIndex = index;

        const coord = element.coordinates[index];
        this.savedAbsX = coord.absX;
        this.savedAbsY = coord.absY;

        // Save references to the coords that will form the merged segment
        let segBefore = element.segments.find(s => s.end === coord);
        let segAfter = element.segments.find(s => s.start === coord);
        this.mergedStart = segBefore?.start;
        this.mergedEnd = segAfter?.end;
    }

    findMergedSegmentIndex() {
        return this.element.segments.findIndex(s =>
            s.start === this.mergedStart && s.end === this.mergedEnd
        );
    }

    finish() {
        this.element.removeCoordinateAtIndex(this.coordIndex);
        this.provider.actions.finish();
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }

    undo() {
        let segIdx = this.findMergedSegmentIndex();
        this.newCoord = this.element.insertCoordinateOnSegment(segIdx, this.savedAbsX, this.savedAbsY);
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }

    redo() {
        this.element.removeCoordinateAtIndex(this.coordIndex);
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }
}
